import { useState, useEffect } from 'react';
import axios from 'axios';

export const useVATGroups = () => {
  const [vatGroups, setVatGroups] = useState([]);
  const [loading,   setLoading]   = useState(true);

  useEffect(() => {
    const headers = { Authorization: `Bearer ${localStorage.getItem('token')}` };
    axios.get(`${process.env.REACT_APP_API_URL}/api/academics/vat-posting-groups`, { headers })
      .then(r => setVatGroups(r.data))
      .catch(() => setVatGroups([]))
      .finally(() => setLoading(false));
  }, []);

  return { vatGroups, loading };
};
